// extracted by mini-css-extract-plugin
var _1 = "FkO_qqCdgNGW0juimlxu";
var _2 = "OfYSZkgAVtl24ChyOCDB";
export { _1 as "collapseOnSmallScreens", _2 as "row" }
